export const LOCAL_STORAGE_KEYS = {
  SUBSCRIPTIONS_MODAL_RETURN_URL: "subscriptions_modal_return_url",
  MEDIUM_FETCH_TIME: "medium_fetch_time",
  COOKIE_CONSENT: "darvin_cookie_consent",
  LOW_TOKEN_WARNING_DISMISSED: "low_token_warning_dismissed",
};
